/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagKeyStringValueRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TagKeyStringValueRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return TagKeyStringValueRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TagKeyStringValueRegexQueryOperator>): TagKeyStringValueRegexQueryOperator {
        let obj = Object.assign(new TagKeyStringValueRegexQueryOperator(), model);
        TagKeyStringValueRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagKeyStringValueRegexQueryOperator>): TagKeyStringValueRegexQueryOperator {
        if (!model) return null;
        return TagKeyStringValueRegexQueryOperator.newInstance(<TagKeyStringValueRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagKeyStringValueRegexQueryOperator) {
        if (!obj) return;

        models.TagKeyStringValueRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagKeyStringValueRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagKeyStringValueRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tag_value_regex) {
            models.Regex.fixupPrototype(this.tag_value_regex);
        }
    }

    /**
     * Namespace label key to identify which label to select
     */
    tag_key: string;

    /**
     * Include responses where the label value has the given string
     */
    tag_value_regex: models.Regex;

    /**
     * Tag kind if applicable
     */
    tag_kind: string;

}
